export default __webpack_public_path__ + "static/media/step-action.19fa076f.svg";